const cache = require("memory-cache");

import { get } from "util/apiRequest";

import getLogger from "../../logger/index";
import config from "lib/config";
export const LINKINGMODULES_REQUEST = "LINKINGMODULES_REQUEST";
export const LINKINGMODULES_SUCCESS = "LINKINGMODULES_SUCCESS";
export const LINKINGMODULES_FAILURE = "LINKINGMODULES_FAILURE";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
const log = getLogger("LINKINGMODULES_REQUEST");

export function LinkingModulesRequest() {
  return {
    type: LINKINGMODULES_REQUEST,
    status: REQUESTING,
  };
}
export function LinkingModulesSuccess(linkingModulesData) {
  return {
    type: LINKINGMODULES_SUCCESS,
    status: SUCCESS,
    linkingModulesData: linkingModulesData,
  };
}
export function LinkingModulesFailure(error) {
  return {
    type: LINKINGMODULES_FAILURE,
    status: ERROR,
    error,
  };
}

/**
 * @desc transform linking module data to be consumable by the RDC-UI widget
 * @param {String} title [Link title]
 * @param {Array} list [List of title-url pair links]
 * @returns {Object} [Title and text-href pair links]
 */
export const transformToGeoLinks = ({ title, list }) => {
  return {
    title,
    geoLinks: list.map(({ title, url }) => {
      return { text: title, href: url };
    }),
  };
};

export function linkingModules() {
  return async (dispatch) => {
    const url = `${config.FRONTDOOR_CLIENT}/seo-zoho/api/v1/linking-modules?client_id=FAR2.0&status=far`;
    try {
      dispatch(LinkingModulesRequest());
      let resultJson = cache.get(url);
      if (!resultJson) {
        resultJson = await get(url);
        cache.put(url, resultJson, 3600000); //time is in milliseconds 1 hour.
      }
      if (resultJson.status !== 200) {
        cache.put(url, null, 360000);
        throw new Error("Linking module error");
      }
      const linkingModulesData = resultJson?.data;
      const { linking_module } = linkingModulesData || {};
      const popularCities = linking_module?.popular_cities
        ? transformToGeoLinks(linking_module?.popular_cities)
        : {};
      const popularNCCities = linking_module?.popular_new_construction_cities
        ? transformToGeoLinks(linking_module?.popular_new_construction_cities)
        : {};
      const popularRecentlySoldCities = linking_module?.popular_recently_sold_cities
        ? transformToGeoLinks(linking_module?.popular_recently_sold_cities)
        : {};
      const realStateResources = linking_module?.real_estate_resources
        ? transformToGeoLinks(linking_module?.real_estate_resources)
        : {};

      const transformedData = [
        popularCities,
        popularNCCities,
        popularRecentlySoldCities,
        realStateResources,
      ];
      return dispatch(LinkingModulesSuccess(transformedData));
    } catch (error) {
      log.error("Error while fetching linking modules API data", error);
      cache.put(url, null, 360000);
      return dispatch(LinkingModulesFailure(error.message));
    }
  };
}
